var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Auth'),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-12 col-lg-11 col-xl-10 mx-auto"},[_c('router-view',{on:{"alert":function($event){return _vm.newAlert($event)}}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }